import * as THREE from 'three'
import {SectionBase} from "./SectionBase.js";


export default class ChatbotSection extends SectionBase{
    constructor(_options){
        super(_options)
        // Add all project from the list
    }

    setItemConfigs() {
        this.list = [
            {
                name: 'Three.js Journey2',
                interactionTypes: ['chatbot'],
                x: 40,
                y: -10,
                useTiles: true,
                imageSources:
                    [
                        './models/projects/threejsJourney/slideA.webp',
                        './models/projects/threejsJourney/slideB.webp',
                        './models/projects/threejsJourney/slideC.webp'
                    ],
                floorTexture: this.resources.items.projectsThreejsJourneyFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/standardseite_184.de.jsp',
                        x: - 4.8,
                        y: - 3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                        {type: 'chatbot', x: -8, y: -1, mass: 0}
                    ]
            },
        ]
    }

    setGeometries() {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes() {
        this.meshes = {}
        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({
            transparent: true,
            depthWrite: false,
            color: 0xffffff,
            alphaMap: this.resources.items.areaOpenTexture
        }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setWalls() {
    }

    setRoads() {
    }

    setStatic() {
    }
}